import React, {useEffect, useRef} from "react";
import $ from "jquery";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {getCurrentGroups} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import LookMainWizardSelectedStep from "../../../lookNavigation/lookMain/lookMainWizardSelectedStep";


const GroheWizardSelectedSteps = (props) => {

  const {wizardActiveItem, wizardSelectedValues, wizardActiveStep, isMobile, styles} = props;

  const stepsContainerElement = useRef();

  useEffect(() => {
    if (styles && styles.width && stepsContainerElement && stepsContainerElement.current) {
      $(stepsContainerElement.current).animate({scrollLeft: stepsContainerElement.current.scrollWidth}, 800);
    }
  }, [styles])

  if (!wizardActiveItem || !wizardSelectedValues || !Object.keys(wizardSelectedValues).length) {
    return null
  }

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  return (
    <div className={"grohe-wizard__steps" + (isCompletedStep && !isMobile ? " grohe-wizard__steps--finished" : "")
      + (isMobile ? " grohe-wizard__steps--mobile" : "")} ref={stepsContainerElement}>
      <ul className="lw-steps__list lw-steps__list--column" style={styles}>
        {Object.keys(wizardSelectedValues).reverse().map((key) => {
          return <LookMainWizardSelectedStep wizardSelectedValue={wizardSelectedValues[key]}
                                             useMobile={isMobile}
                                             stepIndex={+key}
                                             key={"wizValue" + key}/>
        })}
      </ul>
    </div>
  )
};

GroheWizardSelectedSteps.propTypes = {
  isMobile: PropTypes.bool
}

const mapStateToProps = (store, ownProps) => {
  const {wizardActiveItem, wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {isMobile} = ownProps;
  const {windowWidth} = store.serverState;

  let styles = null;
  if (isMobile) {
    const scrollContainerWidth = windowWidth - 360;
    const prevStep = wizardActiveStep - 1;
    if ((scrollContainerWidth < prevStep * 100)) {
      const scrollContainerWidth = windowWidth - 360;
      let i = 0;
      let amountOfVisibleSteps = 0;
      while (i < prevStep) {
        if ((scrollContainerWidth - (i * 100)) < 100) {
          amountOfVisibleSteps++;
        }
        i++;
      }
      // console.log("amountOfVisibleSteps", amountOfVisibleSteps);
      styles = {
        width: `calc(100% + ${amountOfVisibleSteps * 100}px)`
      }
    }
  }

  return {
    wizardActiveItem,
    wizardSelectedValues,
    wizardActiveStep,
    isMobile,
    windowWidth,
    styles
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(GroheWizardSelectedSteps)
